import React, { useState } from "react";

const PrivacyPolicy = (props) => {

  return (

    <div>
     <h1 style={{marginLeft:"50px"}}>PrivacyPolicy</h1>
    </div>
  );
};

export default PrivacyPolicy;
